module.exports = __webpack_public_path__ + "static/media/haiti-21-a-2114.68f01d48.jpg";